module.exports = __webpack_public_path__ + "static/media/temp2.9e5768c9.png";